import { render, staticRenderFns } from "./infrastructure.vue?vue&type=template&id=6af78c1d&scoped=true&"
import script from "./infrastructure.vue?vue&type=script&lang=js&"
export * from "./infrastructure.vue?vue&type=script&lang=js&"
import style0 from "./infrastructure.vue?vue&type=style&index=0&id=6af78c1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af78c1d",
  null
  
)

export default component.exports